import { useState, useEffect } from "react";

const EmergencyBanner = ({ notification }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (!notification || notification.length < 2) return;

    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === notification.length - 1 ? 0 : prevIndex + 1
      );
    }, 20000); 

    return () => clearInterval(timer);
  }, [notification]);

  if (!notification || !notification.length) return null;

  const current = notification[currentIndex];

  return (
    <div className="relative h-[3vh] w-full overflow-hidden bg-red-600 text-white">
      {/* Wrapper for the entire banner content */}
      <div className="absolute w-full h-full animate-slide-left flex items-center">
        <div
          key={current.id}
          className="flex w-max items-center gap-2 px-4 py-1"
        >
          <svg className="h-5 w-5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
            <path
              fillRule="evenodd"
              d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
              clipRule="evenodd"
            />
          </svg>
          <span className="font-semibold whitespace-nowrap">
            Emergency Warning: {current.title}
          </span>
        </div>
      </div>

      {/* Animation Keyframes */}
      <style jsx>{`
        @keyframes slide-left {
          0% {
            transform: translateX(100%);
          }
          100% {
            transform: translateX(-100%);
          }
        }

        .animate-slide-left {
          animation: slide-left 20s linear infinite;
        }
      `}</style>
    </div>
  );
};

export default EmergencyBanner;